import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-skill-category-video-script",
  "use": "icon-skill-category-video-script-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-skill-category-video-script\">\r\n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n    <rect x=\"3.25\" y=\"3.25\" width=\"17.5\" height=\"17.5\" rx=\"1.75\" />\r\n    <path d=\"M3.25 8.25h17.5M8 3.25l-3 5M14 3.25l-3 5M20 3.25l-3 5M7.25 12.75h9.5M7.25 16.75h6\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol